import * as React from 'react';

/**
 * Hook to set the autofocus attribute on an element.
 * To make it work with dialogs:
 * @see https://github.com/facebook/react/issues/23301
 */
export function useAutoFocus(ref: React.RefObject<unknown>, autoFocus: boolean) {
    React.useEffect(() => {
        const element = ref.current;
        if (!element || !(element instanceof HTMLElement)) {
            return;
        }
        if (autoFocus) {
            element.setAttribute('autofocus', 'true');
            element.focus();
        } else {
            element.removeAttribute('autofocus');
        }
    }, [autoFocus, ref]);
}
